import { DataBean } from "../../DataBean";


export class HealthDisabilityType extends DataBean {




    public async getHealthDisabilityTypeCatalog(idState:any,regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthDisabilityTypeCatalog_Number_String_Number_Number", [idState,regexStr, page, recordsPerPage]);
    }
public async deleteHealthDisabilityType(idHealthDisabilityType: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteHealthDisabilityType_Number", [idHealthDisabilityType]);
    }
}